export default "__VITE_ASSET__DX21Ip78__"